module.exports = __webpack_public_path__ + "img/blk.c3484863.jpg";